import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/",
)({
  beforeLoad: () => {
    throw redirect({
      to: "/my/settings/account/billing/payments",
      replace: true,
    });
  },
});
